import React, { useContext } from "react";
import PropTypes from "prop-types";
import { Box } from "theme-ui";
import moment from "moment";

import { CurrencyContext } from "./CurrencyContext";
import { cn } from "@coninsa-s2/utils";

function CurrencyPrice({ isCenter }) {
  const currencySettings = useContext(CurrencyContext);
  const date = moment().format("DD/MM/YYYY");

  return (
    <div>
      <div
        className={cn(
          "flex gap-2 mb-2",
          isCenter ? "justify-center" : "justify-start"
        )}
      >
        {["cop", "usd", "eur"].map((currencyType) => (
          <button
            key={`bnt-${currencyType}`}
            onClick={() => currencySettings.setCurrency(currencyType)}
            className={cn(
              "border border-stone-300 text-stone-500 px-2 py-1 rounded-lg uppercase font-bold text-sm hover:border-stone-400",
              currencyType === currencySettings.currency &&
                "border-s2-teal text-s2-teal hover:border-s2-teal"
            )}
          >
            {currencyType}
          </button>
        ))}
      </div>

      <div className="text-sm max-w-[37rem]">
        Este precio está calculado según la TRM del día {date}, tomada del Banco
        de la República y corresponde a una aproximación sobre el precio en
        pesos colombianos. Los términos y condiciones del proyecto, son los
        aplicados al valor en pesos.
      </div>
    </div>
  );
}

CurrencyPrice.defaultProps = {
  isCenter: false,
};

CurrencyPrice.propTypes = {
  isCenter: PropTypes.bool,
};

export default CurrencyPrice;
